export default __webpack_public_path__ + "static/media/Scythe.bb37264a.jpg";